import seek, { seekTypes } from '@adc/seek';
export const searchListings = ({ seekType = seekTypes.LISTINGS, operationName = 'searchListings', dsl = {}, fields = [], fieldsConfig, sortField = 'update_date', sortDirection = 'desc', paginationState = {
    pageSize: 25,
    offset: 0,
}, }) => {
    const seeker = seek
        .for(seekType)
        .operationName(operationName)
        .dsl(dsl)
        .fields(fields, fieldsConfig)
        .sortByField(sortField, sortDirection)
        .size(paginationState.pageSize)
        .offset(paginationState.offset);
    return seeker.execute().then(({ data, errors, }) => {
        const result = {
            data: data.seek,
            errors,
        };
        return result;
    });
};
//# sourceMappingURL=listings.js.map